import { Component, OnDestroy, OnInit } from '@angular/core';
import { DeviceDataService } from "../shared/services/device-data.service";
import { ProjectRouteStationWithParam } from "../../project/shared/interfaces/project-route-station.class";
import { GroupService } from "../../project/shared/services/group.service";
import { ProjectService } from "../../project/shared/services/project.service";
import { ProjectImageData } from "../../project/shared/interfaces/project-image-data.interface";
import { Subscription } from 'rxjs';

@Component({
  selector: 'avs-device-route-station',
  templateUrl: './device-route-station.component.html',
  styleUrls: ['./device-route-station.component.css']
})
export class DeviceRouteStationComponent implements OnInit, OnDestroy {
  public routeStationWithDeviceParam?: ProjectRouteStationWithParam;
  public projectImages: ProjectImageData[] = [];
  public routeStationWithDeviceParamWithoutDeChannels?: ProjectRouteStationWithParam;
  private subscriptionCollection: Subscription[] = [];
  private projectRouteStationsWithParamSubscription?: Subscription;

  constructor(private readonly deviceDataService: DeviceDataService,
    private readonly groupService: GroupService,
    private readonly projectService: ProjectService) {
    this.projectRouteStationsWithParamSubscription = deviceDataService.routeStationWithDeviceParam.subscribe(station => {
      this.routeStationWithDeviceParam = station;
      /*      this.routeStationWithDeviceParamWithoutDeChannels = this.filterDeChannels(station!); */
      if (station) {
        this.testBlock()
        if (station.routeStation.groupId !== null)
          this.getProjectImages(station.routeStation.groupId)
      }
    });

  }

  public ngOnInit(): void {
    this.subscriptionCollection.push(this.projectRouteStationsWithParamSubscription!);
  }

  public ngOnDestroy(): void {
    this.subscriptionCollection.forEach(sub => sub.unsubscribe());
  }

  public testBlock() {

    let originalObject = this.routeStationWithDeviceParam?.routeStation
    const keyToRemove: keyof ProjectRouteStationWithParam['routeStation'] = 'dataEndChannels';

    const newObject = Object.assign({}, originalObject);
    delete newObject[keyToRemove];
    this.routeStationWithDeviceParam!.routeStation = newObject;
  }


  // function to remove DataEndChannel Object from routestation array
  public filterDeChannels(station: ProjectRouteStationWithParam) {
    delete this.routeStationWithDeviceParam?.routeStation.dataEndChannels;
    return this.routeStationWithDeviceParam;
  }


  private getProjectImages(groupId: number) {
    if (groupId === null) return;
    this.groupService.getProjectGroup(groupId).subscribe(group => {
      this.projectService.getAllRouteStationImages(group.projectId).subscribe(images => {
        this.projectImages = images;
      });
    });
  }

}
